import { ApiAudience, ApiProject } from "@incendium/api";
import { audienceService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchAudiences = async (project: ApiProject) => {
  const audiences = await audienceService.audienceServiceListAudiences({
    projectId: project.id as number,
  });
  return audiences.results || [];
};

export const useAudiences = () => {
  const { state, setState, loading, refetch, fetched } = useProjectSharedState(
    "audiences",
    [],
    fetchAudiences
  );

  return {
    audiences: state as ApiAudience[],
    setAudiences: setState,
    loading,
    refetchAudiences: refetch,
    fetched,
  };
};
